import type {BadgeAction} from '@/types/loyalty';

import BadgeActionItem from './BadgeActionItem';

type BadgeActionListProps = {
    actions: BadgeAction[];
};

const BadgeActionList = ({actions}: BadgeActionListProps) => {
    // The first not-completed action is "current" (clickable).
    // Subsequent not-completed actions are "locked" (shown with a lock icon, no
    // interaction).
    const currentActionId = actions.find((a) => !a.isCompleted)?.id;

    return (
        <ul className='m-0 flex w-full list-none flex-col gap-1 p-0'>
            {actions.map((action) => (
                <BadgeActionItem key={action.id} action={action} isCurrent={action.id === currentActionId} />
            ))}
        </ul>
    );
};

export default BadgeActionList;
